"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingResizeTimeoutMs = exports.PendingOrientationChangeTimeoutMs = exports.OrientationChange = void 0;
var PendingOrientationChangeTimeoutMs = 250;
exports.PendingOrientationChangeTimeoutMs = PendingOrientationChangeTimeoutMs;
var PendingResizeTimeoutMs = 200;
exports.PendingResizeTimeoutMs = PendingResizeTimeoutMs;
/**
 * Helper class that "re-fires" an orientation change event only after we think the window has resized, which helps bridge differences
 * between how orientation change is handled on different platforms.
 * There is no guarantee that every orientation change event fired from the window will be mirrored here.
 *
 * Notes on how the eventing works in different scenarios:
 * In iOS, the order is resize -> orientation change.
 * In Android, the order is orientation change -> resize.
 * When in an iframe, either OS will propagate the orientation change event to the iframe's window. The resize only occurs if the
 * parent document happens to resize the iframe, so the order and timing of the two events will depend on how the parent document
 * responds to the event. Currently we won't fire if no resize occurs, which prevents false alarms in the iframe case.
 */
var OrientationChange = /** @class */ (function () {
    function OrientationChange() {
    }
    OrientationChange.init = function () {
        window.addEventListener('orientationchange', OrientationChange.handleOrientationChange);
        window.addEventListener('resize', OrientationChange.handleResize);
    };
    OrientationChange.handleOrientationChange = function () {
        if (OrientationChange.latestPendingResizeTimestamp !== null &&
            Date.now() - OrientationChange.latestPendingResizeTimestamp <= PendingResizeTimeoutMs) {
            /* Resize occurred recently, assume this is the iOS case and fire. */
            OrientationChange.fireOrientationChange();
        }
        else {
            /* No resize occurred recently, but record the timestamp for the Android case where a resize is about to occur. */
            OrientationChange.latestPendingOrientationChangeTimestamp = Date.now();
        }
    };
    OrientationChange.handleResize = function () {
        if (OrientationChange.latestPendingOrientationChangeTimestamp !== null &&
            Date.now() - OrientationChange.latestPendingOrientationChangeTimestamp <= PendingOrientationChangeTimeoutMs) {
            /* Orientation change occurred recently, assume this is the Android case and fire. */
            OrientationChange.fireOrientationChange();
        }
        else {
            /**
             * No orientation change occurred recently, but record the timestamp for the iOS case where an orientation change is about
             * to occur.
             */
            OrientationChange.latestPendingResizeTimestamp = Date.now();
        }
    };
    /**
     * Public only for testing convenience.
     * Notify listeners that an orientation change has occurred and the window has resized already.
     */
    OrientationChange.fireOrientationChange = function () {
        OrientationChange.latestPendingOrientationChangeTimestamp = null;
        OrientationChange.latestPendingResizeTimestamp = null;
        OrientationChange.listeners.forEach(function (callback) { callback(); });
    };
    /**
     * Register a callback when an orientation change occurs.
     */
    OrientationChange.addListener = function (callback) {
        if (callback) {
            OrientationChange.listeners.push(callback);
        }
    };
    /**
     * Unregister a callback that has been previously registered.
     */
    OrientationChange.removeListener = function (callback) {
        OrientationChange.listeners = OrientationChange.listeners.filter(function (element) {
            return element !== callback;
        });
    };
    OrientationChange.latestPendingOrientationChangeTimestamp = null;
    OrientationChange.latestPendingResizeTimestamp = null;
    OrientationChange.listeners = [];
    return OrientationChange;
}());
exports.OrientationChange = OrientationChange;
OrientationChange.init();
//# sourceMappingURL=OrientationChange.js.map